import { render } from "./CommissionEventsHistory.vue?vue&type=template&id=39d4359c&scoped=true"
import script from "./CommissionEventsHistory.vue?vue&type=script&lang=js"
export * from "./CommissionEventsHistory.vue?vue&type=script&lang=js"

import "./CommissionEventsHistory.vue?vue&type=style&index=0&id=39d4359c&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d4359c"]])

export default __exports__